import $ from 'jquery'

export class ProductArguments {

	constructor($container) {
		$container.find('.product-arguments-slider').on('setPosition', function (event, slick) {
			slick.$slides.css('height', slick.$slideTrack.height() + 'px')
		})
	}
}
